import styled from '../styled-components';
export default styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-11abj45-0"
})(["border:1px solid ", ";border-radius:3px;background-color:", ";padding:14px 15px;font-family:'Lato',sans-serif;font-size:14px;height:45px;line-height:17px;outline:none;&::-moz-focus-inner{border:0;}width:100%;::placeholder{color:", ";}&:hover,&:focus{border-color:", ";}&:disabled{background-color:", ";border:1px solid ", ";color:", ";}&[aria-invalid='true']{border-color:", ";}&:read-only{background-color:", ";color:#656565;}"], function (props) {
  return props.theme.color.grey.light;
}, function (props) {
  return props.theme.color.text.white;
}, function (props) {
  return props.theme.color.grey.mid;
}, function (props) {
  return props.theme.color.primary.lightBlue;
}, function (props) {
  return props.theme.color.grey.whiteGrey;
}, function (props) {
  return props.theme.color.grey.light;
}, function (props) {
  return props.theme.color.grey.dark;
}, function (props) {
  return props.theme.color.primary.red;
}, function (props) {
  return props.theme.color.grey.white;
});